import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { getNotifications } from "../../firebase/services";
import { format } from "date-fns";
import { useLanguage } from "../../hooks/useLanguage";

export default function SupervisorNotifications() {
  const { user } = useAuth();
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    getNotifications(user.uid, "supervisor").then(n => { setNotifs(n); setLoading(false); });
  }, [user]);

  const { t } = useLanguage();
  if (loading) return <div style={{ color: "#888", padding: 20 }}>{t("common.loading")}</div>;

  return (
    <>
      <div className="page-header">
        <div><h1>{t("notif.title")}</h1><p>{t("notif.from_admin")}</p></div>
      </div>
      {notifs.length === 0 ? (
        <div className="card" style={{ textAlign: "center", padding: 40, color: "#aaa" }}>{t("notif.no_notifs")}</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {notifs.map(n => (
            <div key={n.id} className="card">
              <div style={{ fontWeight: 600, marginBottom: 4 }}>{n.title}</div>
              <div style={{ color: "#555", fontSize: 14, whiteSpace: "pre-wrap" }}>{n.body}</div>
              {n.type === "bonus_program" && <Link to="/supervisor/programs" className="btn btn-sm" style={{ marginTop: 8 }}>🎁 {t("bp.view")}</Link>}
              {n.fileUrl && <a href={n.fileUrl} target="_blank" rel="noreferrer" style={{ color: "#2563eb", fontSize: 13, marginTop: 8, display: "block" }}>📎 Tệp đính kèm</a>}
              <div style={{ fontSize: 11, color: "#aaa", marginTop: 8 }}>
                {n.createdAt?.toDate ? format(n.createdAt.toDate(), "dd/MM/yyyy HH:mm") : ""}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
